import { render, staticRenderFns } from "./ChoicePopUp.vue?vue&type=template&id=a36478d6&scoped=true"
import script from "./ChoicePopUp.vue?vue&type=script&lang=js"
export * from "./ChoicePopUp.vue?vue&type=script&lang=js"
import style0 from "./ChoicePopUp.vue?vue&type=style&index=0&id=a36478d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36478d6",
  null
  
)

export default component.exports